<template>
  <div>
    <!-- 订单列表 -->
    <baseBreadcrumb :page="$t('message.orderList')" :menu="$t('message.orderManagement')"></baseBreadcrumb>
    <div class="body">
      <!-- 状态筛选 -->
      <div class="tabs">
        <el-tabs v-model="statusRange" type="card" @tab-click="search">
          <el-tab-pane :label="item.name + `(${item.count})`" :name="item.statusRange" v-for="(item, index) in tabs"
            :key="index">
          </el-tab-pane>
        </el-tabs>
      </div>
      <!-- 搜索 -->
      <div class="search">
        <div class="row">
          <!-- 开始日期-->
          <div class="item">
            <el-date-picker v-model="datas.dateStart" :placeholder="$t('message.startDate')" class="Container"
              type="datetime" default-time="['00:00:00']" value-format="yyyy-MM-dd HH:mm:ss" style="width: 240px">
            </el-date-picker>
          </div>
          <!--  结束日期-->
          <div class="item">
            <el-date-picker v-model="datas.dateEnd" :placeholder="$t('message.dateClosed')" class="Container"
              default-time="['23:59:59']" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" style="width: 240px">
            </el-date-picker>
          </div>
          <!-- 注文書番号 -->
          <div class="item">
            <el-input v-model="datas.order_sn" placeholder="注文書番号" clearable onfocus="this.select()"></el-input>
          </div>
          <!-- 全部账号 -->
          <div class="item">
            <el-select v-model="datas.operation_id" placeholder="全部账号">
              <el-option v-for="item in options" :key="item.id" :label="item.realname" :value="item.id">
              </el-option>
            </el-select>
          </div>

          <!-- 搜索 -->
          <el-button type="primary" @click="search">
            {{ $t("message.search") }}
          </el-button>
          <!-- 重置 -->
          <el-button @click="reset">
            {{ $t("message.reset") }}
          </el-button>

          <!-- 操作 -->
        </div>
        <div class="operation">
          <!-- 帮客户提订单 -->
          <router-link :to="'/orderPreview?userID=' + datas.user_id" target="_blank" v-if="isAuth(454)">
            <el-button type="primary">
              {{ $t("message.helpCustomersPickUpOrders") }}
            </el-button>
          </router-link>
        </div>
      </div>
      <!-- 列表 -->
      <div class="table">
        <ol>
          <li class="flex05">NO</li>
          <!-- 注文書 -->
          <li class="flex2">注文書</li>
          <!-- 下单账号 -->
          <li>下单账号</li>
          <!-- 提出日付 -->
          <li>提出日付</li>
          <!-- 入金日 -->
          <li>入金日</li>
          <!-- 買付完了 -->
          <li>買付完了</li>
          <!-- エクセル導出 -->
          <li>エクセル導出</li>
          <!-- 注文書状態 -->
          <li>注文書状態</li>
          <!-- 操作 -->
          <li class="flex15">操作</li>
        </ol>
        <ul v-for="(item, index) in list" :key="index">
          <li class="flex05">{{ index + 1 }}</li>
          <!-- 注文書 -->
          <li class="flex2">
            <div class="template">
              <!-- 手机下单标记 -->
              <span v-if="item.from_tool != 1" style="vertical-align: middle;"><img src="@/assets/icon/mobile.png"
                  alt="" style="width: 25px;"></span>
              <router-link :to="`/${item.status <= 40 ? 'orderDetail' : 'orderPaymentDetail'
                }?order_sn=` + item.order_sn
                " target="_blank">
                {{ item.order_sn }}
              </router-link>
              <i class="el-icon-copy-document" @click="copy(item.order_sn)"></i>
              <p>{{ item.realname }}</p>
            </div>
          </li>
          <!-- 下单账号 -->
          <li>
            <div class="template">
              <p>{{ item.is_main ? "主账号" : "子账号" }}</p>
              <p>{{ item.user.realname }}
                <el-popover placement="top-start" trigger="hover"
                  v-if="item.children_user != null && item.children_user != false" title="子账号信息">
                  <p>{{ $t('message.names') }}:{{ item.children_user.children_username }}</p>
                  <p>ID:{{ item.children_user.id }}</p>
                  <img src="@/assets/user/children_user.png" alt="" slot="reference" style="vertical-align: middle;">
                </el-popover>
              </p>
            </div>
          </li>
          <!-- 提出日付 -->
          <li>{{ item.created_at }}</li>
          <!-- 入金日 -->
          <li>
            {{
              item.order_time_node
                ? item.order_time_node.datetime_pay_submit
                : "--"
            }}
          </li>
          <!-- 買付完了 -->
          <li>
            {{
              item.order_time_node
                ? item.order_time_node.datetime_purchase_complete
                : "--"
            }}
          </li>
          <!-- エクセル導出 -->
          <li>
            <a :href="baseURL + '/client.orderDetailDownload?order_sn=' + item.order_sn">
              <i class="el-icon-sold-out"></i></a>
          </li>
          <!-- 注文書状態 -->
          <li>
            <span v-if="item.part_pay_status"> {{ item.part_pay_status_name }}</span>
            <span v-else> {{ item.status_name }}</span>
          </li>
          <!-- 操作 -->
          <li class="flex15">
            <el-button size="mini" type="primary" class="dark" v-if="item.status == 10">
              {{ $t("message.delete") }}
            </el-button>
            <!-- 支付 -->
            <el-button size="mini" type="primary" class="primary"
              v-else-if="(item.status == 30 && detail.is_pay_authorized && isAuth(164)) || (item.status == 30 && detail.credit > 0)"
              @click="$router.push({
                name: 'payPage', query: {
                  order_sn: item.order_sn,
                  userID: $route.query.userID,
                }
              })">
              {{ $t("message.pay") }}
            </el-button>
            <el-button size="mini" type="primary" class="primary"
              v-else-if="(item.part_pay_status == 3 && detail.is_pay_authorized && isAuth(164)) || (item.part_pay_status == 3 && detail.credit > 0)"
              @click="$router.push({
                name: 'payPage', query: {
                  order_sn: item.order_sn,
                  userID: $route.query.userID,
                }
              })">
              {{ $t("message.pay") }}
            </el-button>
            <span v-else>--</span>
          </li>
        </ul>
        <!-- 暂无数据 -->
        <div v-if="list == false" class="No_data">暂无数据</div>
      </div>
      <!-- 分页 -->
      <div class="paginationContainer">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="datas.page"
          :page-sizes="[10, 20, 50, 100]" :page-size="datas.pageSize" layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      tabs: [],
      options: [],
      statusRange: "10",
      datas: {
        user_id: this.$route.query.userID,
        statusRange: [],
        order_sn: "",
        dateStart: "",
        dateEnd: "",
        operation_id: "",
      },
      total: 0,
      list: [],
      detail: {},
    };
  },
  created() {
    this.$api.clienteleApi.clientDetail({ user_id: this.datas.user_id }).then(res => {
      this.detail = res.data
    })
    this.relationAccounts();
    this.orderTabList().then(() => {
      this.orderList();
    });
  },
  methods: {
    orderTabList() {
      return this.$api.clienteleApi.orderTabList(this.datas).then((res) => {
        res.data.forEach((item) => {
          item.statusRange = item.statusRange.join(",");
        });
        this.tabs = res.data;
        this.setRouteStatusRange();
      });
    },
    // 从订单预览提出订单后，默认定位到包含已提出状态的“确认中”标签。
    setRouteStatusRange() {
      if (this.$route.query.status !== "confirming") return;
      const confirmingTab = this.tabs.find((item) =>
        item.statusRange.split(",").includes("20")
      );
      if (confirmingTab) {
        this.statusRange = confirmingTab.statusRange;
      }
    },
    //客户的主账号及子账号筛选
    relationAccounts() {
      this.$api.clienteleApi.relationAccounts(this.datas).then((res) => {
        this.options = res.data;
      });
    },
    // 订单列表
    orderList() {
      if (this.statusRange) {
        this.datas.statusRange = this.statusRange.split(",");
      }
      this.$api.clienteleApi.orderList(this.datas).then((res) => {
        this.list = res.data.data;
        this.total = res.data.total;
      });
    },

    // 搜索
    search() {
      this.datas.page = 1;
      this.orderList();
    },
    // 重置
    reset() {
      this.statusRange = "10";
      this.datas = {
        user_id: this.$route.query.userID,
        statusRange: [],
        order_sn: "",
        dateStart: "",
        dateEnd: "",
        operation_id: "",
      };

      this.$forceUpdate();
      this.orderList();
    },
    // 分页
    handleCurrentChange(val) {
      this.datas.page = val;
      this.orderList();
    },
    handleSizeChange(val) {
      this.datas.pageSize = val;
      this.orderList();
    },
    // 下载Excel
    download(order_sn) {
      this.$api.orderDetailDownloadToken({ order_sn }).then(res => {
        console.log(res);
        // let a = document.createElement('a')
        // a.href = `https://jpapi.rakumart.cn/client/download.orderDetailDownload?order_sn=${order_sn}&downloadToken=${res.data.downloadToken}`
        // a.click()

      })
    },
  },
};
</script>
<style lang='scss' scoped>
.search {
  margin: 24px 0;
  position: relative;

  .row {
    display: flex;
    margin-bottom: 16px;

    .item {
      width: 240px;
      margin-right: 24px;
    }
  }

  .operation {
    position: absolute;
    top: 0;
    right: 0;
  }
}

.table {
  .flex05 {
    flex: 0.5;
  }

  .flex15 {
    flex: 1.5;
  }

  .flex2 {
    flex: 2;
  }

  .template {
    text-align: center;

    a {
      color: #fa5058;
      text-decoration: underline;
    }
  }

  .el-icon-sold-out {
    color: #fa5058;
    font-size: 40px;
    cursor: pointer;
  }

  .No_data {
    margin: 20px auto;
    text-align: center;
    font-size: 20px;
  }
}
</style>
